import React, { useCallback } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { Card, CardLoader } from 'src/components';
import { SigningCasesList } from './SigningCasesList';
import { NoAgreementsMessage } from './NoAgreementsMessage';
import { SigningCaseStatusApi } from 'src/models';
import { ISigningCaseListItem } from 'src/models/SigningCase';
import { getRoute } from 'src/routes';
import SigningCaseListActions from 'src/state/SigningCasesList/actions';
import { getAwaitingSigningCases } from 'src/state/SigningCasesList/selectors';

type RouteProps = RouteComponentProps<any>;

interface StateProps {
  signingCases: ReturnType<typeof getAwaitingSigningCases>;
}

interface DispatchProps {
  openSigningCase: typeof SigningCaseListActions.goSigningCaseDetails;
}

type Props = StateProps & DispatchProps & RouteProps & WithTranslation;

const AgreementsReady = ({
  signingCases,
  t,
  openSigningCase,
  history,
  location,
}: Props) => {
  const status: SigningCaseStatusApi = 'AwaitingYourSignature';

  const onSigningCaseClick = useCallback(
    (signignCaseListItem: ISigningCaseListItem, index: number) => {
      openSigningCase({
        history,
        index,
        location,
        signignCaseListItem,
        status,
      });
    },
    [openSigningCase, history, location, status]
  );

  const title = t('AgreementsReadyForYouToSign');
  const loadSigningCases =
    signingCases.list.length > 0 ? (
      <SigningCasesList
        documents={signingCases.list}
        type={'NotSigned'}
        onClick={onSigningCaseClick}
      />
    ) : (
      <NoAgreementsMessage
        aria-label={t('ThereAreNoPendingAgreementsThatRequireYourSignature')}
        to={getRoute('archive')}
      />
    );

  return (
    <Card
      labelText={title}
      title={title}
      popout={true}
      showNotifications={true}
      data-testid="unsigned-signing-cases"
    >
      {signingCases.isLoading ? (
        <CardLoader data-testid="spinner" />
      ) : (
        loadSigningCases
      )}
    </Card>
  );
};

const connectedComponent = connect(
  state => ({
    signingCases: getAwaitingSigningCases(state),
  }),
  {
    openSigningCase: SigningCaseListActions.goSigningCaseDetails,
  }
)(AgreementsReady);

const ExtendedComponent = withRouter(withTranslation()(connectedComponent));
export { ExtendedComponent as AgreementsReadyCard };
